import { useQuery } from '@hooks/reactQuery';

import { getAllCellsForSectors } from '@api/sectors';

import { ICellsForSectorsDto } from '@interfaces/map/dto/sectorsDTO';

import { CELLS_FOR_SITE_SECTORS } from '@constants/queryKeys';

interface ICellForSiteParams {
	siteId?: string;
}

interface IUseQueryCellsForSite {
	cellsForSite?: ICellsForSectorsDto;
	isLoading: boolean;
	isFetching: boolean;
}

export function useQueryCellsForSite({ siteId }: ICellForSiteParams): IUseQueryCellsForSite {
	const {
		data,
		isLoading,
		isInitialLoading,
		isFetching,
	} = useQuery<ICellsForSectorsDto>({
		queryKey: [CELLS_FOR_SITE_SECTORS, siteId],
		queryFn: () => {
			return getAllCellsForSectors([siteId!]);
		},
		enabled: [!!siteId],
	});

	return {
		cellsForSite: data,
		isLoading: isLoading || isInitialLoading,
		isFetching,
	};
}
